import styled from "styled-components";
import { theme } from "../../constants/StyledComponents";

export const StyledFormSection = styled.div`
  display: flex;
  flex-direction: column;

  & .fs-header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    height: ${theme.variables.height_1};
  }

  & .title {
    white-space: nowrap;
    display: flex;
    flex-direction: row;
    align-items: center;
    text-transform: uppercase;
  }
`;
